import React, { Component } from 'react'
import TimeTableComponent from "./TimeTableComponent"
import { connect } from "react-redux"
import lodashUtil from 'lodash'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'
import withAppShell from '../../../hoc/withAppShell/WithAppShell';

class TimeTableContainer extends Component {
    render() {
        return <TimeTableComponent {...this.props} />

    }
}

const mapStateToProps = (state) => {
    let i18n = undefined;
if(lodashUtil.isEmpty(state.i18nMessages.i18n)){
     i18n = getKeyFromLS("i18n");
}else{
    i18n = state.i18nMessages.i18n
}
    return {
        user: state.cognito.user,
        userInformation: state.userProfile.userInformation,
        activeSchool: state.schoolInformation.activeSchool,
        i18n: i18n
    }
}
const mapDispatchToProps = (dispatch) => ({

}
)

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(TimeTableContainer))

